import { useState, useRef } from 'react';
import { User } from 'lucide-react';

const VideoPlayer = ({ videoUrl, videoTags = [], className = '' }) => {
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);

  const handleTimeUpdate = () => {
    if (videoRef.current) {
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  const isTagVisible = (tag) => {
    // Show tag if we're within 3 seconds of the tagged timestamp
    return Math.abs(currentTime - tag.timestamp) < 3;
  };

  return (
    <div className="relative inline-block w-full">
      <video
        ref={videoRef}
        controls
        className={className}
        onTimeUpdate={handleTimeUpdate}
      >
        <source src={videoUrl} type="video/mp4" />
        <source src={videoUrl} type="video/quicktime" />
        Your browser does not support the video tag.
      </video>
      
      {/* Video Tags Overlay */}
      {videoTags && videoTags.length > 0 && videoTags.map((tag, index) => (
        isTagVisible(tag) && (
          <div
            key={index}
            className="absolute bg-purple-600/90 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center gap-1 shadow-lg animate-in fade-in zoom-in pointer-events-none"
            style={{
              left: `${tag.x}%`,
              top: `${tag.y}%`,
              transform: 'translate(-50%, -50%)'
            }}
          >
            <User className="w-3 h-3" />
            {tag.friend_username}
          </div>
        )
      ))}
    </div>
  );
};

export default VideoPlayer;
